import {Box, showMessage, Text} from 'exsportia-components'
import React, {FC, useEffect, useRef} from 'react'

import {subscribeExternalLink} from '../../services/payments/external-link'
import {useLocale} from '../../utils/i18n'
import {useModalActions} from '../../utils/modals'

const ExternalLinkNotice: FC = () => {
  const {l} = useLocale()
  return (
    <Box>
      <Text text={l('external-link-notice')} />
    </Box>
  )
}

// Opens a payment provider's page in a new tab from a click, never from a network callback
// (WBA-3926). Mount once, inside ModalProvider.
export const ExternalLinkGate: FC = () => {
  const {l} = useLocale()
  const {openModal, closeModal} = useModalActions()
  const urlRef = useRef<string | null>(null)

  useEffect(() => {
    return subscribeExternalLink((url) => {
      urlRef.current = url
      openModal({
        title: l('external-link-title'),
        component: <ExternalLinkNotice />,
        settings: {
          footer: {
            submitButton: {
              settings: {
                bg: 'primary',
              },
            },
          },
        },
        footerConfig: {
          submitButton: {
            text: l('external-link-open'),
            onClick: () => {
              const target = urlRef.current
              if (!target) {
                closeModal()
                return
              }
              // Synchronous, inside the click handler: this is what makes the tab allowed.
              const opened = window.open(target, '_blank')
              if (opened) {
                closeModal()
              } else {
                showMessage(l('external-link-blocked'), 'error')
              }
            },
          },
          cancelButton: {
            onClick: closeModal,
          },
        },
      })
    })
    // openModal/closeModal come from context and are stable for the provider's lifetime
  }, [])

  return null
}
